const TTL_MS = 5 * 60 * 1000;

interface QueueEntry {
  files: File[];
  createdAt: number;
}

const queue = new Map<string, QueueEntry>();

function generateId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `pending-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

function sweepStale(now: number): void {
  for (const [id, entry] of queue) {
    if (now - entry.createdAt > TTL_MS) {
      queue.delete(id);
    }
  }
}

export function enqueuePendingFiles(files: File[]): string {
  const now = Date.now();
  sweepStale(now);
  const id = generateId();
  queue.set(id, { files, createdAt: now });
  return id;
}

export function consumePendingFiles(id: string | null | undefined): File[] | null {
  // Also sweep here — if a user pastes once and idles, enqueue isn't called
  // again, and the only other sweep site (enqueuePendingFiles) never fires.
  // Without this, stale File refs sit in memory past TTL.
  sweepStale(Date.now());
  if (!id) return null;
  const entry = queue.get(id);
  if (!entry) return null;
  queue.delete(id);
  return entry.files;
}

export function discardPendingFiles(id: string | null | undefined): void {
  if (!id) return;
  queue.delete(id);
}
